import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  THIRD_PARTY_XERO_URL_AUTH,
  THIRD_PARTY_XERO_CHECK_STATUS,
  THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN,
  THIRD_PARTY_XERO_ASSIGN_TENANT,
  THIRD_PARTY_XERO_SYNC_MANUAL,
  THIRD_PARTY_XERO_UNASSIGN_TENANT,
  THIRD_PARTY_GOOGLE_URL_AUTH,
  THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN,
  THIRD_PARTY_HMRC_URL_AUTH,
  THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS,
  THIRD_PARTY_BRIGHTPAY_URL_AUTH,
  THIRD_PARTY_BRIGHTPAY_CHECK_STATUS,
  THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN,
  THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER,
  THIRD_PARTY_BRIGHTPAY_UNASSIGN,
  THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES,
  THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST,
  THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS,
  THIRD_PARTY_GPSLIVE_CHECK_STATUS,
  THIRD_PARTY_GPSLIVE_TEST_CONNECTION,
  THIRD_PARTY_GPSLIVE_UNASSIGN,
  THIRD_PARTY_VAPI_LIST,
  THIRD_PARTY_VAPI_DATA,
  THIRD_PARTY_VAPI_CREATE,
  THIRD_PARTY_VAPI_UPDATE,
  THIRD_PARTY_VAPI_DELETE,
  THIRD_PARTY_VAPI_PROVISION,
  THIRD_PARTY_VAPI_LINK_TWILIO,
  THIRD_PARTY_VAPI_TOGGLE,
  CALL_PROVIDER_LIST,
  TELEPHONE_NUMBER_AVAILABLE,
  TELEPHONE_NUMBER_PURCHASE,
  TELEPHONE_NUMBER_LIST,
} from "./actionType";

import {
  thirdPartyXeroUrlAuthSuccess,
  thirdPartyXeroUrlAuthFailure,
  thirdPartyXeroCheckStatusSuccess,
  thirdPartyXeroCheckStatusFailure,
  thirdPartyXeroGenerateAccessTokenSuccess,
  thirdPartyXeroGenerateAccessTokenFailure,
  thirdPartyXeroAssignTenantSuccess,
  thirdPartyXeroAssignTenantFailure,
  thirdPartyXeroSyncManualSuccess,
  thirdPartyXeroSyncManualFailure,
  thirdPartyXeroUnassignTenantSuccess,
  thirdPartyXeroUnassignTenantFailure,
  thirdPartyGoogleUrlAuthSuccess,
  thirdPartyGoogleUrlAuthFailure,
  thirdPartyGoogleGenerateAccessTokenSuccess,
  thirdPartyGoogleGenerateAccessTokenFailure,
  thirdPartyHmrcUrlAuthSuccess,
  thirdPartyHmrcUrlAuthFailure,
  thirdPartyBrightPaySaveCredentialsSuccess,
  thirdPartyBrightPaySaveCredentialsFailure,
  thirdPartyBrightPayUrlAuthSuccess,
  thirdPartyBrightPayUrlAuthFailure,
  thirdPartyBrightPayCheckStatusSuccess,
  thirdPartyBrightPayCheckStatusFailure,
  thirdPartyBrightPayGenerateAccessTokenSuccess,
  thirdPartyBrightPayGenerateAccessTokenFailure,
  thirdPartyBrightPayAssignEmployerSuccess,
  thirdPartyBrightPayAssignEmployerFailure,
  thirdPartyBrightPayUnassignSuccess,
  thirdPartyBrightPayUnassignFailure,
  thirdPartyBrightPaySyncEmployeesSuccess,
  thirdPartyBrightPaySyncEmployeesFailure,
  thirdPartyBrightPayEmployeeListSuccess,
  thirdPartyBrightPayEmployeeListFailure,
  thirdPartyGpsLiveSaveCredentialsSuccess,
  thirdPartyGpsLiveSaveCredentialsFailure,
  thirdPartyGpsLiveCheckStatusSuccess,
  thirdPartyGpsLiveCheckStatusFailure,
  thirdPartyGpsLiveTestConnectionSuccess,
  thirdPartyGpsLiveTestConnectionFailure,
  thirdPartyGpsLiveUnassignSuccess,
  thirdPartyGpsLiveUnassignFailure,
  thirdPartyVapiListSuccess,
  thirdPartyVapiListFailure,
  thirdPartyVapiDataSuccess,
  thirdPartyVapiDataFailure,
  thirdPartyVapiCreateSuccess,
  thirdPartyVapiCreateFailure,
  thirdPartyVapiUpdateSuccess,
  thirdPartyVapiUpdateFailure,
  thirdPartyVapiDeleteSuccess,
  thirdPartyVapiDeleteFailure,
  thirdPartyVapiProvisionSuccess,
  thirdPartyVapiProvisionFailure,
  thirdPartyVapiLinkTwilioSuccess,
  thirdPartyVapiLinkTwilioFailure,
  thirdPartyVapiToggleSuccess,
  thirdPartyVapiToggleFailure,
  callProviderListSuccess,
  callProviderListFailure,
  telephoneNumberAvailableSuccess,
  telephoneNumberAvailableFailure,
  telephoneNumberPurchaseSuccess,
  telephoneNumberPurchaseFailure,
  telephoneNumberListSuccess,
  telephoneNumberListFailure,
} from "./action";

import {
  thirdPartyXeroUrlAuthApi,
  thirdPartyXeroCheckStatusApi,
  thirdPartyXeroGenerateAccessTokenApi,
  thirdPartyXeroAssignTenantApi,
  thirdPartyXeroSyncManualApi,
  thirdPartyXeroUnassignTenantApi,
  thirdPartyGoogleUrlAuthApi,
  thirdPartyGoogleGenerateAccessTokenApi,
  thirdPartyHmrcUrlAuthApi,
  thirdPartyBrightPaySaveCredentialsApi,
  thirdPartyBrightPayUrlAuthApi,
  thirdPartyBrightPayCheckStatusApi,
  thirdPartyBrightPayGenerateAccessTokenApi,
  thirdPartyBrightPayAssignEmployerApi,
  thirdPartyBrightPayUnassignApi,
  thirdPartyBrightPaySyncEmployeesApi,
  thirdPartyBrightPayEmployeeListApi,
  thirdPartyGpsLiveSaveCredentialsApi,
  thirdPartyGpsLiveCheckStatusApi,
  thirdPartyGpsLiveTestConnectionApi,
  thirdPartyGpsLiveUnassignApi,
  thirdPartyVapiListApi,
  thirdPartyVapiDataApi,
  thirdPartyVapiCreateApi,
  thirdPartyVapiUpdateApi,
  thirdPartyVapiDeleteApi,
  thirdPartyVapiProvisionApi,
  thirdPartyVapiLinkTwilioApi,
  thirdPartyVapiToggleApi,
  callProviderListApi,
  telephoneNumberAvailableApi,
  telephoneNumberPurchaseApi,
  telephoneNumberListApi,
} from "../../helpers/fakebackend_helper";

//Third Party Xero Url Auth
function* thirdPartyXeroUrlAuthSaga() {
  try {
    const response = yield call(thirdPartyXeroUrlAuthApi);
    yield put(thirdPartyXeroUrlAuthSuccess(response));
  } catch (error) {
    yield put(thirdPartyXeroUrlAuthFailure(error));
  }
}

function* watchThirdPartyXeroUrlAuthSaga() {
  yield takeEvery(THIRD_PARTY_XERO_URL_AUTH, thirdPartyXeroUrlAuthSaga);
}

//Third Party Xero Check Status
function* thirdPartyXeroCheckStatusSaga() {
  try {
    const response = yield call(thirdPartyXeroCheckStatusApi);
    yield put(thirdPartyXeroCheckStatusSuccess(response));
  } catch (error) {
    yield put(thirdPartyXeroCheckStatusFailure(error));
  }
}

function* watchThirdPartyXeroCheckStatusSaga() {
  yield takeEvery(THIRD_PARTY_XERO_CHECK_STATUS, thirdPartyXeroCheckStatusSaga);
}

//Third Party Xero Generate Access Token
function* thirdPartyXeroGenerateAccessTokenSaga({ payload }) {
  try {
    const response = yield call(thirdPartyXeroGenerateAccessTokenApi, payload);
    yield put(thirdPartyXeroGenerateAccessTokenSuccess(response));
  } catch (error) {
    yield put(thirdPartyXeroGenerateAccessTokenFailure(error));
  }
}

function* watchThirdPartyXeroGenerateAccessTokenSaga() {
  yield takeEvery(
    THIRD_PARTY_XERO_GENERATE_ACCESS_TOKEN,
    thirdPartyXeroGenerateAccessTokenSaga
  );
}

//Third Party Xero Assign Tenant
function* thirdPartyXeroAssignTenantSaga({ payload }) {
  try {
    const response = yield call(thirdPartyXeroAssignTenantApi, payload);
    yield put(thirdPartyXeroAssignTenantSuccess(response));
  } catch (error) {
    yield put(thirdPartyXeroAssignTenantFailure(error));
  }
}

function* watchThirdPartyXeroAssignTenantSaga() {
  yield takeEvery(
    THIRD_PARTY_XERO_ASSIGN_TENANT,
    thirdPartyXeroAssignTenantSaga
  );
}

//Third Party Xero Sync Manual
function* thirdPartyXeroSyncManualSaga() {
  try {
    const response = yield call(thirdPartyXeroSyncManualApi);
    yield put(thirdPartyXeroSyncManualSuccess(response));
  } catch (error) {
    yield put(thirdPartyXeroSyncManualFailure(error));
  }
}

function* watchThirdPartyXeroSyncManualSaga() {
  yield takeEvery(THIRD_PARTY_XERO_SYNC_MANUAL, thirdPartyXeroSyncManualSaga);
}

//Third Party Xero Unassign Tenant
function* thirdPartyXeroUnassignTenantSaga() {
  try {
    const response = yield call(thirdPartyXeroUnassignTenantApi);
    yield put(thirdPartyXeroUnassignTenantSuccess(response));
  } catch (error) {
    yield put(thirdPartyXeroUnassignTenantFailure(error));
  }
}

function* watchThirdPartyXeroUnassignTenantSaga() {
  yield takeEvery(
    THIRD_PARTY_XERO_UNASSIGN_TENANT,
    thirdPartyXeroUnassignTenantSaga
  );
}
//Third Party Google Url Auth
function* thirdPartyGoogleUrlAuthSaga() {
  try {
    const response = yield call(thirdPartyGoogleUrlAuthApi);
    yield put(thirdPartyGoogleUrlAuthSuccess(response));
  } catch (error) {
    yield put(thirdPartyGoogleUrlAuthFailure(error));
  }
}
function* watchThirdPartyGoogleUrlAuthSaga() {
  yield takeEvery(THIRD_PARTY_GOOGLE_URL_AUTH, thirdPartyGoogleUrlAuthSaga);
}
//Third Party Google Generate Access Token
function* thirdPartyGoogleGenerateAccessTokenSaga({ payload }) {
  try {
    const response = yield call(
      thirdPartyGoogleGenerateAccessTokenApi,
      payload
    );
    yield put(thirdPartyGoogleGenerateAccessTokenSuccess(response));
  } catch (error) {
    yield put(thirdPartyGoogleGenerateAccessTokenFailure(error));
  }
}
function* watchThirdPartyGoogleGenerateAccessTokenSaga() {
  yield takeEvery(
    THIRD_PARTY_GOOGLE_GENERATE_ACCESS_TOKEN,
    thirdPartyGoogleGenerateAccessTokenSaga
  );
}

//Third Party HMRC Url Auth
function* thirdPartyHmrcUrlAuthSaga() {
  try {
    const response = yield call(thirdPartyHmrcUrlAuthApi);
    yield put(thirdPartyHmrcUrlAuthSuccess(response));
  } catch (error) {
    yield put(thirdPartyHmrcUrlAuthFailure(error));
  }
}

function* watchThirdPartyHmrcUrlAuthSaga() {
  yield takeEvery(THIRD_PARTY_HMRC_URL_AUTH, thirdPartyHmrcUrlAuthSaga);
}

//Third Party BrightPay Save Credentials
function* thirdPartyBrightPaySaveCredentialsSaga({ payload }) {
  try {
    const response = yield call(thirdPartyBrightPaySaveCredentialsApi, payload);
    yield put(thirdPartyBrightPaySaveCredentialsSuccess(response));
  } catch (error) {
    yield put(thirdPartyBrightPaySaveCredentialsFailure(error));
  }
}
function* watchThirdPartyBrightPaySaveCredentialsSaga() {
  yield takeEvery(
    THIRD_PARTY_BRIGHTPAY_SAVE_CREDENTIALS,
    thirdPartyBrightPaySaveCredentialsSaga
  );
}

//Third Party BrightPay Url Auth
function* thirdPartyBrightPayUrlAuthSaga() {
  try {
    const response = yield call(thirdPartyBrightPayUrlAuthApi);
    yield put(thirdPartyBrightPayUrlAuthSuccess(response));
  } catch (error) {
    yield put(thirdPartyBrightPayUrlAuthFailure(error));
  }
}
function* watchThirdPartyBrightPayUrlAuthSaga() {
  yield takeEvery(THIRD_PARTY_BRIGHTPAY_URL_AUTH, thirdPartyBrightPayUrlAuthSaga);
}

//Third Party BrightPay Check Status
function* thirdPartyBrightPayCheckStatusSaga() {
  try {
    const response = yield call(thirdPartyBrightPayCheckStatusApi);
    yield put(thirdPartyBrightPayCheckStatusSuccess(response));
  } catch (error) {
    yield put(thirdPartyBrightPayCheckStatusFailure(error));
  }
}
function* watchThirdPartyBrightPayCheckStatusSaga() {
  yield takeEvery(
    THIRD_PARTY_BRIGHTPAY_CHECK_STATUS,
    thirdPartyBrightPayCheckStatusSaga
  );
}

//Third Party BrightPay Generate Access Token
function* thirdPartyBrightPayGenerateAccessTokenSaga({ payload }) {
  try {
    const response = yield call(
      thirdPartyBrightPayGenerateAccessTokenApi,
      payload
    );
    yield put(thirdPartyBrightPayGenerateAccessTokenSuccess(response));
  } catch (error) {
    yield put(thirdPartyBrightPayGenerateAccessTokenFailure(error));
  }
}
function* watchThirdPartyBrightPayGenerateAccessTokenSaga() {
  yield takeEvery(
    THIRD_PARTY_BRIGHTPAY_GENERATE_ACCESS_TOKEN,
    thirdPartyBrightPayGenerateAccessTokenSaga
  );
}

//Third Party BrightPay Assign Employer
function* thirdPartyBrightPayAssignEmployerSaga({ payload }) {
  try {
    const response = yield call(thirdPartyBrightPayAssignEmployerApi, payload);
    yield put(thirdPartyBrightPayAssignEmployerSuccess(response));
  } catch (error) {
    yield put(thirdPartyBrightPayAssignEmployerFailure(error));
  }
}
function* watchThirdPartyBrightPayAssignEmployerSaga() {
  yield takeEvery(
    THIRD_PARTY_BRIGHTPAY_ASSIGN_EMPLOYER,
    thirdPartyBrightPayAssignEmployerSaga
  );
}

//Third Party BrightPay Unassign
function* thirdPartyBrightPayUnassignSaga() {
  try {
    const response = yield call(thirdPartyBrightPayUnassignApi);
    yield put(thirdPartyBrightPayUnassignSuccess(response));
  } catch (error) {
    yield put(thirdPartyBrightPayUnassignFailure(error));
  }
}
function* watchThirdPartyBrightPayUnassignSaga() {
  yield takeEvery(THIRD_PARTY_BRIGHTPAY_UNASSIGN, thirdPartyBrightPayUnassignSaga);
}

//Third Party BrightPay Sync Employees
function* thirdPartyBrightPaySyncEmployeesSaga() {
  try {
    const response = yield call(thirdPartyBrightPaySyncEmployeesApi);
    yield put(thirdPartyBrightPaySyncEmployeesSuccess(response));
  } catch (error) {
    yield put(thirdPartyBrightPaySyncEmployeesFailure(error));
  }
}
function* watchThirdPartyBrightPaySyncEmployeesSaga() {
  yield takeEvery(
    THIRD_PARTY_BRIGHTPAY_SYNC_EMPLOYEES,
    thirdPartyBrightPaySyncEmployeesSaga
  );
}

//Third Party BrightPay Employee List
function* thirdPartyBrightPayEmployeeListSaga() {
  try {
    const response = yield call(thirdPartyBrightPayEmployeeListApi);
    yield put(thirdPartyBrightPayEmployeeListSuccess(response));
  } catch (error) {
    yield put(thirdPartyBrightPayEmployeeListFailure(error));
  }
}
function* watchThirdPartyBrightPayEmployeeListSaga() {
  yield takeEvery(
    THIRD_PARTY_BRIGHTPAY_EMPLOYEE_LIST,
    thirdPartyBrightPayEmployeeListSaga
  );
}

//Third Party GPSLive Save Credentials
function* thirdPartyGpsLiveSaveCredentialsSaga({ payload }) {
  try {
    const response = yield call(thirdPartyGpsLiveSaveCredentialsApi, payload);
    yield put(thirdPartyGpsLiveSaveCredentialsSuccess(response));
  } catch (error) {
    yield put(thirdPartyGpsLiveSaveCredentialsFailure(error));
  }
}
function* watchThirdPartyGpsLiveSaveCredentialsSaga() {
  yield takeEvery(
    THIRD_PARTY_GPSLIVE_SAVE_CREDENTIALS,
    thirdPartyGpsLiveSaveCredentialsSaga
  );
}

//Third Party GPSLive Check Status
function* thirdPartyGpsLiveCheckStatusSaga() {
  try {
    const response = yield call(thirdPartyGpsLiveCheckStatusApi);
    yield put(thirdPartyGpsLiveCheckStatusSuccess(response));
  } catch (error) {
    yield put(thirdPartyGpsLiveCheckStatusFailure(error));
  }
}
function* watchThirdPartyGpsLiveCheckStatusSaga() {
  yield takeEvery(
    THIRD_PARTY_GPSLIVE_CHECK_STATUS,
    thirdPartyGpsLiveCheckStatusSaga
  );
}

//Third Party GPSLive Test Connection
function* thirdPartyGpsLiveTestConnectionSaga() {
  try {
    const response = yield call(thirdPartyGpsLiveTestConnectionApi);
    yield put(thirdPartyGpsLiveTestConnectionSuccess(response));
  } catch (error) {
    yield put(thirdPartyGpsLiveTestConnectionFailure(error));
  }
}
function* watchThirdPartyGpsLiveTestConnectionSaga() {
  yield takeEvery(
    THIRD_PARTY_GPSLIVE_TEST_CONNECTION,
    thirdPartyGpsLiveTestConnectionSaga
  );
}

//Third Party GPSLive Unassign
function* thirdPartyGpsLiveUnassignSaga() {
  try {
    const response = yield call(thirdPartyGpsLiveUnassignApi);
    yield put(thirdPartyGpsLiveUnassignSuccess(response));
  } catch (error) {
    yield put(thirdPartyGpsLiveUnassignFailure(error));
  }
}
function* watchThirdPartyGpsLiveUnassignSaga() {
  yield takeEvery(THIRD_PARTY_GPSLIVE_UNASSIGN, thirdPartyGpsLiveUnassignSaga);
}

//Third Party Virtual Receptionist List
function* thirdPartyVapiListSaga() {
  try {
    const response = yield call(thirdPartyVapiListApi);
    yield put(thirdPartyVapiListSuccess(response));
  } catch (error) {
    yield put(thirdPartyVapiListFailure(error));
  }
}
function* watchThirdPartyVapiListSaga() {
  yield takeEvery(THIRD_PARTY_VAPI_LIST, thirdPartyVapiListSaga);
}

//Third Party Virtual Receptionist Data
function* thirdPartyVapiDataSaga({ payload }) {
  try {
    const response = yield call(thirdPartyVapiDataApi, payload);
    yield put(thirdPartyVapiDataSuccess(response));
  } catch (error) {
    yield put(thirdPartyVapiDataFailure(error));
  }
}
function* watchThirdPartyVapiDataSaga() {
  yield takeEvery(THIRD_PARTY_VAPI_DATA, thirdPartyVapiDataSaga);
}

//Third Party Virtual Receptionist Create
function* thirdPartyVapiCreateSaga({ payload }) {
  try {
    const response = yield call(thirdPartyVapiCreateApi, payload);
    yield put(thirdPartyVapiCreateSuccess(response));
  } catch (error) {
    yield put(thirdPartyVapiCreateFailure(error));
  }
}
function* watchThirdPartyVapiCreateSaga() {
  yield takeEvery(THIRD_PARTY_VAPI_CREATE, thirdPartyVapiCreateSaga);
}

//Third Party Virtual Receptionist Update
function* thirdPartyVapiUpdateSaga({ payload }) {
  try {
    const response = yield call(thirdPartyVapiUpdateApi, payload);
    yield put(thirdPartyVapiUpdateSuccess(response));
  } catch (error) {
    yield put(thirdPartyVapiUpdateFailure(error));
  }
}
function* watchThirdPartyVapiUpdateSaga() {
  yield takeEvery(THIRD_PARTY_VAPI_UPDATE, thirdPartyVapiUpdateSaga);
}

//Third Party Virtual Receptionist Delete
function* thirdPartyVapiDeleteSaga({ payload }) {
  try {
    const response = yield call(thirdPartyVapiDeleteApi, payload);
    yield put(thirdPartyVapiDeleteSuccess(response));
  } catch (error) {
    yield put(thirdPartyVapiDeleteFailure(error));
  }
}
function* watchThirdPartyVapiDeleteSaga() {
  yield takeEvery(THIRD_PARTY_VAPI_DELETE, thirdPartyVapiDeleteSaga);
}

//Third Party VAPI Provision
function* thirdPartyVapiProvisionSaga({ payload }) {
  try {
    const response = yield call(thirdPartyVapiProvisionApi, payload);
    yield put(thirdPartyVapiProvisionSuccess(response));
  } catch (error) {
    yield put(thirdPartyVapiProvisionFailure(error));
  }
}
function* watchThirdPartyVapiProvisionSaga() {
  yield takeEvery(THIRD_PARTY_VAPI_PROVISION, thirdPartyVapiProvisionSaga);
}

//Third Party VAPI Link Twilio
function* thirdPartyVapiLinkTwilioSaga({ payload }) {
  try {
    const response = yield call(thirdPartyVapiLinkTwilioApi, payload);
    yield put(thirdPartyVapiLinkTwilioSuccess(response));
  } catch (error) {
    yield put(thirdPartyVapiLinkTwilioFailure(error));
  }
}
function* watchThirdPartyVapiLinkTwilioSaga() {
  yield takeEvery(THIRD_PARTY_VAPI_LINK_TWILIO, thirdPartyVapiLinkTwilioSaga);
}

//Third Party VAPI Toggle
function* thirdPartyVapiToggleSaga({ payload }) {
  try {
    const response = yield call(thirdPartyVapiToggleApi, payload);
    yield put(thirdPartyVapiToggleSuccess(response));
  } catch (error) {
    yield put(thirdPartyVapiToggleFailure(error));
  }
}
function* watchThirdPartyVapiToggleSaga() {
  yield takeEvery(THIRD_PARTY_VAPI_TOGGLE, thirdPartyVapiToggleSaga);
}

//Call Provider List
function* callProviderListSaga() {
  try {
    const response = yield call(callProviderListApi);
    yield put(callProviderListSuccess(response));
  } catch (error) {
    yield put(callProviderListFailure(error));
  }
}
function* watchCallProviderListSaga() {
  yield takeEvery(CALL_PROVIDER_LIST, callProviderListSaga);
}

//Telephone Number Available
function* telephoneNumberAvailableSaga({ payload }) {
  try {
    const response = yield call(telephoneNumberAvailableApi, payload);
    yield put(telephoneNumberAvailableSuccess(response));
  } catch (error) {
    yield put(telephoneNumberAvailableFailure(error));
  }
}
function* watchTelephoneNumberAvailableSaga() {
  yield takeEvery(TELEPHONE_NUMBER_AVAILABLE, telephoneNumberAvailableSaga);
}

//Telephone Number Purchase
function* telephoneNumberPurchaseSaga({ payload }) {
  try {
    const response = yield call(telephoneNumberPurchaseApi, payload);
    yield put(telephoneNumberPurchaseSuccess(response));
  } catch (error) {
    yield put(telephoneNumberPurchaseFailure(error));
  }
}
function* watchTelephoneNumberPurchaseSaga() {
  yield takeEvery(TELEPHONE_NUMBER_PURCHASE, telephoneNumberPurchaseSaga);
}

//Telephone Number List
function* telephoneNumberListSaga() {
  try {
    const response = yield call(telephoneNumberListApi);
    yield put(telephoneNumberListSuccess(response));
  } catch (error) {
    yield put(telephoneNumberListFailure(error));
  }
}
function* watchTelephoneNumberListSaga() {
  yield takeEvery(TELEPHONE_NUMBER_LIST, telephoneNumberListSaga);
}

export default function* ThirdPartyIntegration() {
  yield all([
    fork(watchThirdPartyXeroUrlAuthSaga),
    fork(watchThirdPartyXeroCheckStatusSaga),
    fork(watchThirdPartyXeroGenerateAccessTokenSaga),
    fork(watchThirdPartyXeroAssignTenantSaga),
    fork(watchThirdPartyXeroSyncManualSaga),
    fork(watchThirdPartyXeroUnassignTenantSaga),
    fork(watchThirdPartyGoogleUrlAuthSaga),
    fork(watchThirdPartyGoogleGenerateAccessTokenSaga),
    fork(watchThirdPartyHmrcUrlAuthSaga),
    fork(watchThirdPartyBrightPaySaveCredentialsSaga),
    fork(watchThirdPartyBrightPayUrlAuthSaga),
    fork(watchThirdPartyBrightPayCheckStatusSaga),
    fork(watchThirdPartyBrightPayGenerateAccessTokenSaga),
    fork(watchThirdPartyBrightPayAssignEmployerSaga),
    fork(watchThirdPartyBrightPayUnassignSaga),
    fork(watchThirdPartyBrightPaySyncEmployeesSaga),
    fork(watchThirdPartyBrightPayEmployeeListSaga),
    fork(watchThirdPartyGpsLiveSaveCredentialsSaga),
    fork(watchThirdPartyGpsLiveCheckStatusSaga),
    fork(watchThirdPartyGpsLiveTestConnectionSaga),
    fork(watchThirdPartyGpsLiveUnassignSaga),
    fork(watchThirdPartyVapiListSaga),
    fork(watchThirdPartyVapiDataSaga),
    fork(watchThirdPartyVapiCreateSaga),
    fork(watchThirdPartyVapiUpdateSaga),
    fork(watchThirdPartyVapiDeleteSaga),
    fork(watchThirdPartyVapiProvisionSaga),
    fork(watchThirdPartyVapiLinkTwilioSaga),
    fork(watchThirdPartyVapiToggleSaga),
    fork(watchCallProviderListSaga),
    fork(watchTelephoneNumberAvailableSaga),
    fork(watchTelephoneNumberPurchaseSaga),
    fork(watchTelephoneNumberListSaga),
  ]);
}
